'use client'

// src/components/map/timeline/Context.ts
import { createContext } from "react";
var Context = createContext({
  mode: "monthly"
});

export {
  Context
};
//# sourceMappingURL=chunk-4NAR6N5F.mjs.map